import React from 'react'
import { Box, Divider, Drawer, IconButton, Typography, Chip, Skeleton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ReactJson from 'react-json-view'
import moment from 'moment'

function Row({ label, children, mono }) {
  return (
    <Box style={{ marginBottom: 10 }}>
      <Typography variant="caption" style={{ color: '#888', textTransform: 'uppercase', letterSpacing: 0.4 }}>{label}</Typography>
      <Typography variant="body2" style={{ wordBreak: 'break-all', fontFamily: mono ? 'monospace' : undefined }}>{children ?? '—'}</Typography>
    </Box>
  )
}

function JsonBlock({ label, value }) {
  if (value == null || value === '') return null

  let parsed = null
  if (typeof value === 'object') {
    parsed = value
  } else {
    try { parsed = JSON.parse(value) } catch (e) { parsed = null }
  }

  return (
    <Box style={{ marginTop: 12 }}>
      <Typography variant="caption" style={{ color: '#888', textTransform: 'uppercase', letterSpacing: 0.4 }}>{label}</Typography>
      <Box style={{ backgroundColor: '#1a1a2e', color: '#e0e0e0', borderRadius: 8, padding: 8, marginTop: 4, overflowX: 'auto' }}>
        {parsed != null ? (
          <ReactJson src={parsed} theme="monokai" name={false} collapsed={2} displayDataTypes={false} displayObjectSize={false} enableClipboard style={{ background: 'transparent', fontSize: 12 }} />
        ) : (
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0, fontSize: 12 }}>{String(value)}</pre>
        )}
      </Box>
    </Box>
  )
}

export default function LlmUsageDetailDrawer({ open, row, detail, loading, onClose }) {
  const head = detail || row || {}
  const originLabel = head.origin === 'accompaniment' ? 'Chamado' : 'Chat'
  const data = detail || row || {}

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ className: 'usage-event-drawer', style: { width: 520, maxWidth: '100%', backgroundColor: '#fff' } }}>
      <Box style={{ padding: 16 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <Chip size="small" label={originLabel} style={{ backgroundColor: '#e0e7ff', color: '#3730a3', fontWeight: 600 }} />
            {row && (row.success
              ? <Chip size="small" label="Sucesso" style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600 }} />
              : <Chip size="small" label="Falha" style={{ backgroundColor: '#fee2e2', color: '#991b1b', fontWeight: 600 }} />)}
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon /></IconButton>
        </Box>

        <Typography variant="h6" style={{ marginTop: 8, wordBreak: 'break-all' }}>
          {head.llmname || 'Chamada de IA'}
        </Typography>
        <Typography variant="caption" style={{ color: '#888' }}>
          {head.id != null ? `#${head.id} · ` : ''}{head.createdat ? moment(head.createdat).format('DD/MM/YYYY HH:mm:ss') : '—'}
        </Typography>
        <Divider style={{ margin: '12px 0' }} />

        {loading ? (
          <Box>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular" height={160} style={{ marginTop: 12, borderRadius: 8 }} />
            <Skeleton variant="rectangular" height={160} style={{ marginTop: 12, borderRadius: 8 }} />
          </Box>
        ) : (
          <Box>
            <Row label="ID" mono>{data.id != null ? data.id : '—'}</Row>
            <Row label="Usuário">{data.username ? `${data.username}${data.userid ? ` (#${data.userid})` : ''}` : (data.userid ? `#${data.userid}` : '—')}</Row>
            <Row label="Origem">{originLabel}</Row>
            <Row label="Chamado / Chat de origem" mono>{data.relationedid ? `${originLabel} #${data.relationedid}` : '—'}</Row>
            <Row label="LLM">{data.llmname || '—'}</Row>
            <Row label="Provider">{data.provider || '—'}</Row>
            <Row label="Model" mono>{data.model || '—'}</Row>
            <Row label="Tokens In">{data.tokensinput != null ? data.tokensinput : '—'}</Row>
            <Row label="Tokens Out">{data.tokensoutput != null ? data.tokensoutput : '—'}</Row>
            <Row label="Latência">{data.latencyms != null ? `${data.latencyms} ms` : '—'}</Row>
            <Row label="Custo estimado">{`R$ ${Number(data.estimatedcost || 0).toFixed(4)}`}</Row>
            <Row label="Data">{data.createdat ? moment(data.createdat).format('DD/MM/YYYY HH:mm:ss') : '—'}</Row>
            {!data.success && (
              <Row label="Mensagem de erro">
                <span style={{ color: '#991b1b', whiteSpace: 'pre-wrap' }}>{data.errormessage || '—'}</span>
              </Row>
            )}

            <JsonBlock label="Request" value={data.requestpayload} />
            <JsonBlock label="Response" value={data.responsepayload} />
          </Box>
        )}
      </Box>
    </Drawer>
  )
}
